export default __webpack_public_path__ + "static/playSound-1e719f84c0f07aeb6d995b3b2a71eaa1.png";